import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot} from '@angular/router';
import { Observable } from 'rxjs';

import { Estado } from "src/app/model/estado.model";

import { SolicitacaoDevolucaoHonraService } from './devolucao-honra.service';

@Injectable({ providedIn: 'root'})
export class DevolucaoHonraEstadosResolver implements Resolve<Observable<Estado[]>> {

    constructor(private service: SolicitacaoDevolucaoHonraService) {}

    resolve(route: ActivatedRouteSnapshot
        ): Observable<Estado[]>  {

       return this.service.getEstados();
             
    }
}
